import payload_plugin_qLmFnukI99 from "/opt/build/repo/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/opt/build/repo/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import plugin_wnHB2iVUV4 from "/opt/build/repo/node_modules/@prisma/nuxt/dist/runtime/plugin.mjs";
import supabase_client_2ruDq4uEtU from "/opt/build/repo/node_modules/@nuxtjs/supabase/dist/runtime/plugins/supabase.client.js";
import payload_client_yVLowv6hDl from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/opt/build/repo/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_zlvi6dcIsi from "/opt/build/repo/node_modules/.cache/nuxt/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import presets_1aypKNZ222 from "/opt/build/repo/node_modules/@nuxt/ui-pro/plugins/presets.ts";
import variables_kQtglGecod from "/opt/build/repo/node_modules/@nuxt/ui-pro/plugins/variables.ts";
import plugin_Jozdw60ZsE from "/opt/build/repo/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import plugin_client_RZVNejKJBe from "/opt/build/repo/node_modules/@samk-dev/nuxt-vcalendar/dist/runtime/plugin.client.js";
import plugin_ucMK8VhJjR from "/opt/build/repo/node_modules/nuxt-easy-lightbox/dist/runtime/plugin.mjs";
import cookiebot_plugin_ylR2C5YJqP from "/opt/build/repo/node_modules/@weareheavy/nuxt-cookie-consent/dist/runtime/plugins/cookiebot.plugin.mjs";
import plugin_client_UYiXMU8ZyN from "/opt/build/repo/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import plugin_PSbK9A48ZQ from "/opt/build/repo/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import slideovers_X7whXyrIWR from "/opt/build/repo/node_modules/@nuxt/ui/dist/runtime/plugins/slideovers.js";
import modals_oqljskDzoR from "/opt/build/repo/node_modules/@nuxt/ui/dist/runtime/plugins/modals.js";
import colors_ETtiVmZNmO from "/opt/build/repo/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js";
import plugin_client_OVoKJro5pc from "/opt/build/repo/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_WLsn00x1qh from "/opt/build/repo/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import scrollbars_client_Eg4DPJPcY6 from "/opt/build/repo/node_modules/@nuxt/ui-pro/modules/pro/runtime/plugins/scrollbars.client.ts";
import full_calendar_client_g5GXWAU3Mv from "/opt/build/repo/app/plugins/full-calendar.client.js";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  plugin_wnHB2iVUV4,
  supabase_client_2ruDq4uEtU,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_zlvi6dcIsi,
  prefetch_client_5tzzN0oIVL,
  presets_1aypKNZ222,
  variables_kQtglGecod,
  plugin_Jozdw60ZsE,
  plugin_client_RZVNejKJBe,
  plugin_ucMK8VhJjR,
  cookiebot_plugin_ylR2C5YJqP,
  plugin_client_UYiXMU8ZyN,
  plugin_PSbK9A48ZQ,
  slideovers_X7whXyrIWR,
  modals_oqljskDzoR,
  colors_ETtiVmZNmO,
  plugin_client_OVoKJro5pc,
  plugin_WLsn00x1qh,
  scrollbars_client_Eg4DPJPcY6,
  full_calendar_client_g5GXWAU3Mv
]